import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { PartnerInvoiceDetailFragmentDoc } from '../fragments/partnerInvoice.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPartnerInvoicesForInvoiceCollectionQueryVariables = Types.Exact<{
  invoice_collection_id: Types.Scalars['ID'];
}>;


export type GetPartnerInvoicesForInvoiceCollectionQuery = { __typename?: 'Query', getPartnerInvoicesForInvoiceCollection: Array<{ __typename?: 'PartnerInvoice', id: string, label?: string | null, title?: string | null, store_id?: string | null, note?: string | null, url?: string | null, invoice_number?: string | null, status?: Types.BillomatInvoiceStatus | null, parsed_amount?: string | null, parsed_payment_direction?: string | null, total_net?: string | null, total_gross?: string | null, hidden?: boolean | null, date?: string | null, admin_info?: { __typename?: 'BillomatInvoice', id: string, status?: Types.BillomatInvoiceStatus | null, title?: string | null, label?: string | null, generated_at?: string | null, send_processed_at?: string | null, send_at?: string | null, send_status?: Types.BillomatInvoiceSendStatus | null, send_error?: string | null, send_emails_used?: string | null, send_delivery_id?: string | null, send_delivery_link?: string | null, charged_at?: string | null, charged_amount?: number | null, charged_currency?: Types.Currency | null, charged_transaction_id?: string | null, charged_charge_id?: string | null } | null }> };


export const GetPartnerInvoicesForInvoiceCollectionDocument = gql`
    query GetPartnerInvoicesForInvoiceCollection($invoice_collection_id: ID!) {
  getPartnerInvoicesForInvoiceCollection(
    invoice_collection_id: $invoice_collection_id
  ) {
    ...PartnerInvoiceDetail
  }
}
    ${PartnerInvoiceDetailFragmentDoc}`;

/**
 * __useGetPartnerInvoicesForInvoiceCollectionQuery__
 *
 * To run a query within a React component, call `useGetPartnerInvoicesForInvoiceCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerInvoicesForInvoiceCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerInvoicesForInvoiceCollectionQuery({
 *   variables: {
 *      invoice_collection_id: // value for 'invoice_collection_id'
 *   },
 * });
 */
export function useGetPartnerInvoicesForInvoiceCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerInvoicesForInvoiceCollectionQuery, GetPartnerInvoicesForInvoiceCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerInvoicesForInvoiceCollectionQuery, GetPartnerInvoicesForInvoiceCollectionQueryVariables>(GetPartnerInvoicesForInvoiceCollectionDocument, options);
      }
export function useGetPartnerInvoicesForInvoiceCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerInvoicesForInvoiceCollectionQuery, GetPartnerInvoicesForInvoiceCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerInvoicesForInvoiceCollectionQuery, GetPartnerInvoicesForInvoiceCollectionQueryVariables>(GetPartnerInvoicesForInvoiceCollectionDocument, options);
        }
export type GetPartnerInvoicesForInvoiceCollectionQueryHookResult = ReturnType<typeof useGetPartnerInvoicesForInvoiceCollectionQuery>;
export type GetPartnerInvoicesForInvoiceCollectionLazyQueryHookResult = ReturnType<typeof useGetPartnerInvoicesForInvoiceCollectionLazyQuery>;
export type GetPartnerInvoicesForInvoiceCollectionQueryResult = Apollo.QueryResult<GetPartnerInvoicesForInvoiceCollectionQuery, GetPartnerInvoicesForInvoiceCollectionQueryVariables>;